import { z } from 'zod';

/**
 * Protocolo de trabajador v1 (lado equipo, parte B).
 * Autenticación: Authorization: Bearer dev_<token>. Las operaciones son las
 * `job.worker_*` del registro. Tiempos del servidor; el reloj del PC no decide.
 */
export const WORKER_PROTOCOL = {
  version: '1.0.0',
  lease_seconds: 120,
  heartbeat_interval_seconds: 30,
  fallback_poll_seconds: 60,
  max_technical_failures: 3,
  backoff: 'min(30 * 2^n, 3600) segundos',
} as const;

export const WorkerTokenPrefix = 'dev_' as const;
export const AgentTokenPrefix = 'agt_' as const;

export const JobLifecycle = [
  'crear → waiting_device',
  'claim (atómico, SKIP LOCKED) → claimed; generación +1; lease 120 s',
  'heartbeat cada 30 s → running/verifying; renueva lease',
  'complete(completed) → completed; artefactos del intento vigente',
  'complete(failed, retryable) → waiting_device con backoff; al 3.º fallo → action_required',
  'lease vencido → scheduler: intento expired; waiting_device o action_required',
  'generación antigua en heartbeat/complete → STALE_JOB_ATTEMPT',
  'equipo revocado → AUTH_REQUIRED; intentos activos cancelados',
] as const;

export const WorkerHelloCapabilities = z.record(
  z.enum(['index', 'probe', 'transcribe', 'align', 'render', 'export_capcut', 'analyze_audio']),
  z.enum(['available', 'missing_package', 'incompatible', 'unsupported']),
);
